import * as Yup from 'yup'

export const knowledgeSchema = Yup.object().shape({
  instructions: Yup.string()
    .required('Instructions are required')
    .min(3, 'Instructions must be at least 3 characters')
    .max(500, 'Instructions cannot exceed 500 characters'),
  sub_knowledge: Yup.array().of(
    Yup.object().shape({
      workflow: Yup.string().required('Workflow is required'),
      voice: Yup.string()
        .required('Brand voice is required')
        .min(3, 'Brand voice must be at least 3 characters')
        .max(300, 'Brand voice cannot exceed 300 characters'),
      do_s: Yup.string()
        .required('Dos field is required')
        .min(3, 'Dos field must be at least 3 characters')
        .max(300, 'Dos field cannot exceed 300 characters'),
      don_t: Yup.string()
        .required("Don't field is required")
        .min(3, "Don't field must be at least 3 characters")
        .max(300, "Don't field cannot exceed 300 characters"),
      content_example: Yup.string()
        .required('Content example is required')
        .min(3, 'Content example must be at least 3 characters')
        .max(300, 'Content example cannot exceed 300 characters'),
    })
  ),
})

export const validateField = async (
  field: string,
  value: any,
  setValidationErrors: React.Dispatch<React.SetStateAction<Record<string, string>>>
): Promise<boolean> => {
  try {
    const fieldSchema = Yup.object().shape({
      [field]: (knowledgeSchema.fields as any)[field],
    })

    await fieldSchema.validate({[field]: value}, {abortEarly: false})
    setValidationErrors((prev) => ({...prev, [field]: ''}))
    return true
  } catch (error) {
    if (error instanceof Yup.ValidationError) {
      const errorMessage = error.inner[0]?.message || ''
      setValidationErrors((prev) => ({...prev, [field]: errorMessage}))
    }
    return false
  }
}
